module.exports = __webpack_public_path__ + "static/media/largeFont.9bf10f33.webp";